/*!
 * Copyright (c) 2019 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _classCallCheck = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/inherits");

var AssertionProofPurpose = require('jsonld-signatures').purposes.AssertionProofPurpose;

var CredentialIssuancePurpose =
/*#__PURE__*/
function (_AssertionProofPurpos) {
  _inherits(CredentialIssuancePurpose, _AssertionProofPurpos);

  function CredentialIssuancePurpose() {
    _classCallCheck(this, CredentialIssuancePurpose);

    return _possibleConstructorReturn(this, _getPrototypeOf(CredentialIssuancePurpose).apply(this, arguments));
  }

  return CredentialIssuancePurpose;
}(AssertionProofPurpose);

module.exports = CredentialIssuancePurpose;